export default __webpack_public_path__ + "static/media/img7.f2fd1f16.PNG";